import { CollectionService } from 'services';

const ThematicGroupService = CollectionService('thematicgroups');

export default ThematicGroupService;
